// full focussable list (extend line 29 as required for the project)
// 'a, button, input, textarea, select, details, iframe, embed, object, summary dialog, audio[controls], video[controls], [contenteditable], [tabindex]'

function keyDownListener (elem, keyCode, func, shiftKey = false, prevent = true) {
  elem.addEventListener('keydown', (e) => {
    if (e.keyCode === keyCode && e.shiftKey === shiftKey) {
      func()
      if (prevent) {
        e.preventDefault()
      }
    }
  })
}

// A class to provide focus to popup elements when context is switched.
class Focusable {
  constructor (elem, setup = false) {
    this.elem = elem
    this.eventsAttached = false

    if (setup === true) {
      this.setup()
    }
  }

  get all () {
    return [
      ...this.elem.querySelectorAll(
        'a, button, input, textarea, select, detail, summary'
      )
    ].filter(el => {
      return (
        !el.hasAttribute('disabled') &&
        !el.hasAttribute('hidden') &&
        window.getComputedStyle(el).getPropertyValue('display') !== 'none'
      )
    })
  }

  get keyboardOnly () {
    return this.all.filter(el => el.tabIndex > -1)
  }

  get firstFocusable () {
    return this.keyboardOnly[0]
  }

  get lastFocusable () {
    return this.keyboardOnly[this.length - 1]
  }

  get length () {
    return this.keyboardOnly.length
  }

  focusFirst () {
    this.firstFocusable.focus()
  }

  focusLast () {
    this.lastFocusable.focus()
  }

  setup () {
    if (!this.eventsAttached) {
      // Tab
      keyDownListener(this.lastFocusable, 9, () => {
        this.focusFirst()
      })

      // Shift Tab
      keyDownListener(this.firstFocusable, 9, () => this.focusLast(), true)

      // Home key
      keyDownListener(this.elem, 36, () => this.focusFirst(), false)

      // End key
      keyDownListener(this.elem, 35, () => this.focusLast(), false)
      this.eventsAttached = true
    }
  }

  onEscape (func) {
    keyDownListener(this.elem, 27, func, false, false)
  }
}

export {
  Focusable
}
